import { type PrescriptionPrescriptionTypeEnum } from '@redteclab/api/clients/bully'

import { type RxByPrincipleControls } from '../../product'
import { type ProductAddToCartCtaParams } from '../../url-handling'

export interface ProductAddToCartProductPageMainCtaParams extends ProductAddToCartCtaParams {
  cartAction: 'add'
  channel: string
  eventName: 'addToCart_OfferItem' | 'addToCart_PDP'
  eventType: 'conversion'
  offer: string
  prescriptionType: string
  product: string
  quantity: number
  query?: string
  queryID?: string
}

/**
 * adding to cart happens basically via visiting/submitting GET form to "cart intermediate page" with specific query params.
 * this func builds such params for PDP main "add to cart"
 */
export const productAddToCartParamsMakeProductPageMainCtaParams = ({
  channel,
  offerId,
  prescriptionType,
  productId,
  quantity,
  query,
  queryId,
  rxByPrincipleControls,
}: {
  channel: string
  offerId: string
  prescriptionType: PrescriptionPrescriptionTypeEnum
  productId: string
  quantity: number
  query: string
  queryId: string
  rxByPrincipleControls: RxByPrincipleControls
}): ProductAddToCartProductPageMainCtaParams => {
  return {
    cartAction: 'add',
    channel,
    eventName: 'addToCart_PDP',
    eventType: 'conversion',
    offer: offerId,
    prescriptionType,
    product: productId,
    quantity,
    ...(query && { query }),
    ...(queryId && { queryID: queryId }),
    ...(rxByPrincipleControls.isReasonRequired && {
      [rxByPrincipleControls.queryParamName]:
        rxByPrincipleControls.selectedReason,
    }),
  }
}
